import RealtimeKitClient from "@cloudflare/realtimekit";

// Module-level single-flight so React StrictMode double-effects
// do not start two RealtimeKitClient.init() calls for the same token.
const inflightInitsByTokenKey = new Map();

const tokenKey = (token) =>
  `${token.length}:${token.slice(0, 12)}:${token.slice(-8)}`;

/**
 * Initialize a RealtimeKit client from a participant authToken.
 * Safe under React StrictMode (single-flight per token).
 */
export const initRealtimeKitMeeting = (authToken, defaults = { audio: true, video: true }) => {
  if (!authToken) {
    return Promise.reject(new Error("Missing RealtimeKit authToken"));
  }

  const key = tokenKey(authToken);
  const existing = inflightInitsByTokenKey.get(key);
  if (existing) {
    return existing;
  }

  const initPromise = RealtimeKitClient.init({
    authToken,
    defaults,
  }).finally(() => {
    inflightInitsByTokenKey.delete(key);
  });

  inflightInitsByTokenKey.set(key, initPromise);
  return initPromise;
};
